export default "__VITE_ASSET__38ede0da__"